<template>
    <section class="content" v-if="carregado">
        <lista-topo :situacaoBuscaAvancada="dSituacaoBuscaAvancada" :aBuscaDados="enviarBuscaAvancada">
            <template #botoes>
                <b-button id="botao-adicionar" variant="success" size="md" class="mr-1 inline-block" @click="abreAdicionarCte()">
                    <i class="fa fa-plus-circle" />
                    Adicionar
                </b-button>
                <b-dropdown
                    id="botao-mais-acoes"
                    ref="botao-mais-acoes"
                    variant="primary"
                    @show="
                        () => {
                            tableFields[0].thClass = 'd-table-cell'
                            tableFields[0].tdClass = 'd-table-cell'
                        }
                    "
                >
                    <template #button-content>
                        <span>
                            <i class="fa fa-gears" />
                            Mais ações
                        </span>
                    </template>
                    <b-dropdown-item-button @click="importarXml()">
                        <i class="fa icon-font icon-file-xml mr-2" />
                        Importar XML's
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="exportarXml()">
                        <i class="fa icon-font icon-file-xml mr-2" />
                        Exportar XML's
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="callCartaCorrecoes">
                        <i class="fa fa-file mr-2" />
                        Cartas de correções
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="exportarExcel()">
                        <i class="fa icon-font icon-file-excel mr-2" />
                        Exportar excel
                    </b-dropdown-item-button>
                    <b-dropdown-item-button>
                        <a :href="`${$urlBase}/configuracoes/certificado_digital`" class="certificado-digital">
                            <i class="fa icon-certificatethree mr-2" />
                            Certificado digital
                        </a>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click.prevent="excluirSelecionados">
                        <i class="fa icon-remove mr-2" />
                        Excluir conhecimentos
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>
            <template #buscaPeriodo>                
                <busca-periodo
                    :dataInicio="filtros.periodoDe"
                    :dataFim="filtros.periodoAte"
                    chaveInicio="periodoDe"
                    chaveFim="periodoAte"
                    :exibeTodoPeriodo="true"
                    @escolhaPeriodo="dSituacaoBuscaAvancada = true"
                />
            </template>
            <template #buscaAvancada>
                <b-col sm="2">
                    <label for="loja">Loja</label>
                    <b-form-select id="lojas" :options="options.lojas" v-model="filtros.loja" />
                </b-col>
                <b-col sm="2">
                    <label for="nCT">Número</label>
                    <b-form-input id="nCT" v-model="filtros.nCT"></b-form-input>
                </b-col>
                <b-col sm="1">
                    <label for="serie">Série</label>
                    <b-form-input id="serie" v-model="filtros.serie"></b-form-input>
                </b-col>
                <b-col sm="7">
                    <label>Período</label>
                    <b-form-input-date-between
                        :start="{
                            name: 'periodoDe',
                            value: filtros.periodoDe
                        }"
                        :end="{
                            name: 'periodoAte',
                            value: filtros.periodoAte
                        }"
                        scope="filtro"
                        @start="atualizaDataInicio($event)"
                        @end="atualizaDataFim($event)"
                    />
                </b-col>
                <b-col sm="3">
                    <label for="nome">Situação</label>
                    <b-form-select :options="options.situacoes" id="situacao" v-model="filtros.situacao">
                        <template #first>
                            <b-select-option value="">Todas</b-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm="3">
                    <label for="nome">Tipo CT-e</label>
                    <b-form-select :options="options.tiposCTe" id="tpCTe" v-model="filtros.tpCTe">
                        <template #first>
                            <b-select-option value="">Todos</b-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm="3">
                    <label for="nome">Tipo de serviço</label>
                    <b-form-select :options="options.tipoServ" id="tpServ" v-model="filtros.tpServ">
                        <template #first>
                            <b-select-option value="">Todos</b-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm="3">
                    <label for="nome">Forma de emissão</label>
                    <b-form-select :options="options.tiposEmissao" id="tpEmis" v-model="filtros.tpEmis">
                        <template #first>
                            <b-select-option value="">Todas</b-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col sm="3">
                    <label for="remetente">Remetente</label>
                    <b-form-input id="remetente" v-model="filtros.remetente"></b-form-input>
                </b-col>
                <b-col sm="3">
                    <label for="destinatario">Destinatário</label>
                    <b-form-input id="destinatario" v-model="filtros.destinatario"></b-form-input>
                </b-col>
                <b-col sm="3">
                    <label for="expedidor">Expedidor</label>
                    <b-form-input id="expedidor" v-model="filtros.expedidor"></b-form-input>
                </b-col>
                <b-col sm="3">
                    <label for="recebedor">Recebedor</label>
                    <b-form-input id="recebedor" v-model="filtros.recebedor"></b-form-input>
                </b-col>
                <b-col sm="3">
                    <label for="tomador">Tomador</label>
                    <b-form-input id="tomador" v-model="filtros.tomador"></b-form-input>
                </b-col>
            </template>
        </lista-topo>

        <div>
            <tabela 
                :permitirGerarFinanceiro="permitirGerarFinanceiro"
            />
        </div>

    </section>
</template>
<script>
import { mapWritableState, mapState, mapActions } from 'pinia'
import { useListaStore } from '../../stores/Lista'
import Tabela from './Tabela'
import BuscaPeriodo from '@/shared/components/crud/lista/ListaTopoPeriodo'
import Lista from '@/shared/common/mixins/Lista'

export default {
    mixins: [Lista],
    props: {
        permitirGerarFinanceiro: {
            default: true
        }
    },
    components: {
        Tabela,
        BuscaPeriodo
    },
    computed: {
        ...mapWritableState(useListaStore, ['filtros', 'dSituacaoBuscaAvancada', 'tableFields']),
        ...mapState(useListaStore, ['carregado', 'options'])
    },
    methods: {
        ...mapActions(useListaStore, [
            'carregaDados',
            'atualizaDataInicio',
            'atualizaDataFim',
            'limpaBuscaAvancada',
            'enviarBuscaAvancada',
            'mounted',
            'verificaPermissao',
            'exportarXml',
            'exportarExcel',
            'importarXml',
            'abreAdicionarCte',
            'excluirSelecionados'
        ]),
        callCartaCorrecoes() {
            const base = this.$urlBase != '/cte' ? `${this.$urlBase}/cte` : this.$urlBase
            this.$router.push(`${base}/cartas-correcoes`)
        }
    },
    mounted() {
        this.mounted(this.$usuarioLogado)
        this.carregaDados(this.$route)
    },
    watch: {
        $route() {
            this.carregaDados(this.$route)
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 512px) {
    .botoes,
    .busca-periodo {
        display: flex !important;
        justify-content: space-between !important;
    }
    .botoes .dropdown,
    .busca-periodo .dropdown {
        flex-grow: 1;
    }
    #busca-simples {
        font-size: 1em;
        height: 38px;
    }
}
</style>
<style>
.certificado-digital,
.certificado-digital i {
    color: black !important;
}
</style>
